















































































import Vue from 'vue'

import moment from 'moment'

export default Vue.extend({
  props: {
    stack: Object,
    value: Object,
  },

  data() {
    return {
      model: {
        timeString: '',
        gasAnalyzer: [
          {
            rowspan: 2,
            name: 'CO',
            label: 'CO',
            value: '####',
            unit: 'ppm',
            precision: 2,
          },
          {
            name: 'CO_MG',
            label: 'CO',
            value: '####',
            unit: 'mg/m<sup>3</sup>',
            precision: 2,
          },
          {
            rowspan: 1,
            name: 'CO_C',
            label: 'CO O<sub>2</sub> CORRECTION',
            value: '####',
            unit: 'mg/Nm<sup>3</sup>',
            precision: 2,
          },
          {
            rowspan: 2,
            name: 'NO',
            label: 'NO',
            value: '####',
            unit: 'ppm',
            precision: 2,
          },
          {
            name: 'NO_MG',
            label: 'NO',
            value: '####',
            unit: 'mg/m<sup>3</sup>',
            precision: 2,
          },
          {
            rowspan: 2,
            name: 'NO2',
            label: 'NO<sub>2</sub>',
            value: '####',
            unit: 'ppm',
            precision: 2,
          },
          {
            name: 'NO2_MG',
            label: 'NO2',
            value: '####',
            unit: 'mg/m<sup>3</sup>',
            precision: 2,
          },
          {
            rowspan: 2,
            name: 'NOX',
            label: 'NOX',
            value: '####',
            unit: 'ppm',
            precision: 2,
          },
          {
            name: 'NOX_MG',
            label: 'NOX',
            value: '####',
            unit: 'mg/m<sup>3</sup>',
            precision: 2,
          },
          {
            rowspan: 1,
            name: 'NOX_C',
            label: 'NOX O<sub>2</sub> CORRECTION',
            value: '####',
            unit: 'mg/Nm<sup>3</sup>',
            precision: 2,
          },
          {
            rowspan: 2,
            name: 'SO2',
            label: 'SO<sub>2</sub>',
            value: '####',
            unit: 'ppm',
            precision: 2,
          },
          {
            name: 'SO2_MG',
            label: 'SO2',
            value: '####',
            unit: 'mg/m<sup>3</sup>',
            precision: 2,
          },
          {
            rowspan: 1,
            name: 'SO2_C',
            label: 'SO<sub>2</sub> O<sub>2</sub> CORRECTION',
            value: '####',
            unit: 'mg/Nm<sup>3</sup>',
            precision: 2,
          },
          {
            rowspan: 1,
            name: 'CO2',
            label: 'CO<sub>2</sub>',
            value: '####',
            unit: 'vol%',
            precision: 2,
          },
          {
            rowspan: 1,
            name: 'H2O',
            label: 'H<sub>2</sub>O',
            value: '####',
            unit: 'vol%',
            precision: 2,
          },
          {
            rowspan: 1,
            name: 'O2',
            label: 'O<sub>2</sub>',
            value: '####',
            unit: 'vol%',
            precision: 2,
          },
        ],

        table1: [
          {
            name: 'DUST',
            label: 'DUST',
            value: '####',
            unit: 'mg/m<sup>3</sup>',
            precision: 2,
          },
          {
            name: 'DUST_C',
            label: 'DUST O<sub>2</sub> CORRECTION',
            value: '####',
            unit: 'mg/Nm<sup>3</sup>',
            precision: 2,
          },
          {
            name: 'OPACITY',
            label: 'OPACITY',
            value: '####',
            unit: '%',
            precision: 2,
          },
          {
            name: 'FLOWRATE',
            label: 'FLOW',
            value: '####',
            unit: 'm<sup>3</sup>/s',
            precision: 2,
          },
          {
            name: 'TEMPERATURE',
            label: 'TEMPERATURE',
            value: '####',
            unit: '<sup>o</sup>C',
            precision: 2,
          },
          {
            name: 'PRESS',
            label: 'PRESSURE',
            value: '####',
            unit: 'hPa',
            precision: 2,
          },
        ],
      },
    }
  },

  methods: {
    updateValue() {
      if (typeof this.value == 'undefined') {
        return
      }
      this.model.timeString = moment(this.value.time).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      for (const i in this.model.gasAnalyzer) {
        const parameter = this.model.gasAnalyzer[i]

        const value = this.value[parameter.name]

        if (typeof value == 'number') {
          this.model.gasAnalyzer[i].value = parameter.precision
            ? value.toFixed(parameter.precision)
            : value.toString()
        } else {
          this.model.gasAnalyzer[i].value = '####'
        }
      }

      for (const i in this.model.table1) {
        const parameter = this.model.table1[i]

        const value = this.value[parameter.name]

        if (typeof value == 'number') {
          this.model.table1[i].value = parameter.precision
            ? value.toFixed(parameter.precision)
            : value.toString()
        } else {
          this.model.table1[i].value = '####'
        }
      }
    },
  },

  watch: {
    value: {
      deep: true,
      handler: function() {
        this.updateValue()
      },
    },
  },

  created() {
    this.updateValue()
  },
})
